import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { IHistory } from '../../interfaces';
import { UserModel } from '../../model/UserModel';

export interface IUserListItemProps {
    instance: UserModel;
    index: number;
    onClick?(val): string;
    history: IHistory;
}

export class UserListItemImpl extends React.PureComponent<IUserListItemProps, {}> {
    constructor(props: IUserListItemProps) {
        super(props);
    }

    static defaultProps: IUserListItemProps;

    render() {
        const { index, instance, history } = this.props;
        return <Row className="form-list-item" >
            <Col
                onClick={() => history.push(`/user-profile/${instance.props.UserId}`)}
                className="clickable-list-item serial-no"
                sm={2} xs={2}
            >
                {instance.props.UserId}
            </Col>
            <Col
                onClick={() => history.push(`/user-profile/${instance.props.id}`)}
                className="clickable-list-item" xs={3}
                sm={4}
            >
                {instance.props.First_Name}
            </Col>
            <Col
                onClick={() => history.push(`/user-profile/${instance.props.id}`)}
                className="clickable-list-item" xs={4}
                sm={3}
            >
                {instance.props.Last_Name}
            </Col>
            <Col
                onClick={() => history.push(`/user-profile/${instance.props.id}`)}
                className="clickable-list-item" xs={3}
                sm={3}
            >
                {instance.props.Access_Level}
            </Col>
        </Row>;
    }
}

export function mapStateToProps(state) {
    return {
        state
    };
}

export const UserListItem = withRouter(connect<{}, {}, IUserListItemProps>(mapStateToProps)(UserListItemImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/UserListItem.tsx